import CandidatesHeroSection from '../components/Candidates/CandidatesHeroSection';
import OurPromiseSection from '../components/Candidates/OurPromiseSection';
import OpportunitiesSection from '../components/Candidates/OpportunitiesSection';
import Silk from '../components/SilkBackground';

function Candidates() {
  return (

    <>
    <div className="fixed inset-0 -z-10 pointer-events-none">
        <Silk
          speed={10}
          scale={1}
          color="#e3c8b3"
          noiseIntensity={1.5}
          rotation={0}
        />
      </div>

    <div className="min-h-screen bg-[#f2d6c0]/80 backdrop-blur-md">
      {/* Hero Section */}
      <CandidatesHeroSection />

      {/* Our Promise Section */}
      <OurPromiseSection />

      {/* Opportunities Section */}
      <OpportunitiesSection />

      
    </div>
    </>
    
  );
}

export default Candidates;
  